package fr.manyverse.app.presentation.components.modules.digicode

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Dialpad
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.digicode_open
import org.jetbrains.compose.resources.stringResource

@Composable
fun DigicodeBubble(
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    FloatingActionButton(
        onClick = onClick,
        containerColor = MaterialTheme.colorScheme.primaryContainer,
        modifier = modifier
    ) {
        Icon(Icons.Default.Dialpad, contentDescription = stringResource(Res.string.digicode_open))
    }
}
